import React, { useState, useRef } from 'react';
import Chatbot from '../Chatbot';

const AIWidgetLauncher = () => {
  const [open, setOpen] = useState(false);
  const [activeWidget, setActiveWidget] = useState(null); // 'ai' | 'chatbot' | null
  const aiWidgetRef = useRef(null);

  // Dynamically load ai-widget.js only when needed
  const showAIWidget = () => {
    setActiveWidget('ai');
    if (!window.__aiWidgetLoaded) {
      const script = document.createElement('script');
      script.src = '/ai-widget.js?v=1.4';
      script.type = 'text/javascript';
      script.onload = () => {
        window.__aiWidgetLoaded = true;
        // Try to show the widget after it's loaded
        setTimeout(() => {
          if (window.Widget && window.widget) {
            try {
              if (!window.widget.open) {
                window.widget.toggleOpen();
              }
            } catch (e) {
              console.warn('Error showing AI widget:', e);
            }
          }
        }, 100);
      };
      document.body.appendChild(script);
    } else {
      // If already loaded, try to show the widget
      if (window.Widget && window.widget) {
        try {
          if (!window.widget.open) {
            window.widget.toggleOpen();
          }
        } catch (e) {
          console.warn('Error showing AI widget:', e);
        }
      } else {
        // If widget instance is missing, recreate it
        try {
          window.widget = new window.Widget();
          window.widget.toggleOpen();
        } catch (e) {
          console.warn('Error recreating AI widget:', e);
        }
      }
    }
  };

  // Hide AI widget by closing it (not removing from DOM)
  const hideAIWidget = () => {
    // Try to close the widget if possible
    if (window.Widget && window.widget) {
      try {
        if (window.widget.open) {
          window.widget.toggleOpen();
        } else {
          // If widget is not open, try to close it anyway
          window.widget.close();
        }
      } catch (e) {
        console.warn('Error hiding AI widget:', e);
      }
    } else {
      // If widget is not loaded, try to remove any existing widget DOM elements
      const existingWidgets = document.querySelectorAll('[style*="position: fixed"][style*="bottom: 30px"][style*="right: 30px"]');
      existingWidgets.forEach(widget => {
        if (widget.textContent.includes('SwiftDoc AI Diagnosis')) {
          widget.remove();
        }
      });
    }
  };

  const handleWidgetSelect = (widget) => {
    setActiveWidget(widget);
    setOpen(false);
    if (widget === 'ai') {
      showAIWidget();
    } else {
      hideAIWidget();
    }
  };

  // Hide both widgets when closing
  const handleClose = () => {
    setActiveWidget(null);
    hideAIWidget();
  };

  return (
    <div style={{
      position: 'fixed',
      bottom: 30,
      right: 30,
      zIndex: 10000,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
    }}>
      {activeWidget === null && (
        <button
          style={{
            background: '#016cb2',
            color: '#fff',
            border: 'none',
            borderRadius: 16,
            padding: '14px 28px',
            fontWeight: 600,
            fontSize: 16,
            boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
            cursor: 'pointer',
          }}
          onClick={() => setOpen((v) => !v)}
        >
          Contact us
        </button>
      )}
      {open && (
        <div style={{
          background: '#fff',
          borderRadius: 16,
          boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
          padding: 16,
          marginBottom: 8,
          minWidth: 220,
          display: 'flex',
          flexDirection: 'column',
          gap: 12,
        }}>
          <button
            style={{
              background: '#016cb2',
              color: '#fff',
              border: 'none',
              borderRadius: 12,
              padding: '10px 18px',
              fontWeight: 500,
              fontSize: 15,
              cursor: 'pointer',
            }}
            onClick={() => handleWidgetSelect('ai')}
          >
            Diagnosis tool
          </button>
          <button
            style={{
              background: '#016cb2',
              color: '#fff',
              border: 'none',
              borderRadius: 12,
              padding: '10px 18px',
              fontWeight: 500,
              fontSize: 15,
              cursor: 'pointer',
            }}
            onClick={() => handleWidgetSelect('chatbot')}
          >
            Talk to us now
          </button>
        </div>
      )}
      {activeWidget === 'chatbot' && (
        <div style={{ position: 'relative', zIndex: 10001 }}>
          <button
            style={{
              position: 'absolute',
              top: -12,
              right: -12,
              background: '#016cb2',
              color: '#fff',
              border: 'none',
              borderRadius: '50%',
              width: 32,
              height: 32,
              fontWeight: 700,
              fontSize: 18,
              cursor: 'pointer',
              zIndex: 10002,
            }}
            onClick={handleClose}
            aria-label="Close Chatbot"
          >
            ×
          </button>
          <Chatbot />
        </div>
      )}
      {/* AI widget is handled by the script and its own DOM, so no need to render here */}
      {activeWidget === 'ai' && (
        <button
          style={{
            position: 'absolute',
            top: -12,
            right: -12,
            background: '#016cb2',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: 32,
            height: 32,
            fontWeight: 700,
            fontSize: 18,
            cursor: 'pointer',
            zIndex: 10002,
          }}
          onClick={handleClose}
          aria-label="Close AI Widget"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default AIWidgetLauncher; 